import React from "react";
import styled from "styled-components";
import VideoUploader from "./VideoUploader";

export function AudioEditor(props){
  const {file, setFile, filePath} = props

  return(
    <FrameContainer>
      <FrameHeader>
        <HeaderIcon aria-hidden="true">
          <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18V5l12-2v13"/>
            <circle cx="6" cy="18" r="3"/>
            <circle cx="18" cy="16" r="3"/>
          </svg>
        </HeaderIcon>
        <span>오디오 파일 업로드</span>
      </FrameHeader>
      <VideoUploader file={file} onSelect={setFile} filePath={filePath}/>
    </FrameContainer>
  )
}

const FrameContainer = styled.div`
  width: 100%;
  max-width: 420px;
  padding: 14px 16px 16px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  background-color: var(--color-surface);
`
const FrameHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding-bottom: 10px;
  margin-bottom: 12px;
  border-bottom: 1px solid #eee;
  color: #333;
  font-size: var(--font-size-15);
  font-weight: 700;
  -ms-user-select: none;
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
`
const HeaderIcon = styled.span`
  display: inline-flex;
  color: ${({theme}) => theme.color.subColor};
`
